import { useQueries } from '@tanstack/react-query'
import type { SavedFilter } from 'api/savedFilters/savedFilters.api'
import { normalizeFilterBlob, parseSavedFilter } from 'store/filter/urlFilter.helper'

const SAVED_FILTER_SELECTIONS_QUERY_KEY = 'savedFilterSelections'

/** What each saved filter selects, by saved filter id. A filter that is still decoding, or cannot be, is absent. */
export function useSavedFilterSelections(savedFilters: SavedFilter[]): Map<number, Record<string, string[]>> {
  const results = useQueries({
    queries: savedFilters.map((savedFilter) => ({
      queryKey: [SAVED_FILTER_SELECTIONS_QUERY_KEY, normalizeFilterBlob(savedFilter.filter.split('&')[0])],
      queryFn: () => parseSavedFilter(savedFilter.filter),
      staleTime: Infinity,
      retry: false,
    })),
  })

  const selectionsById = new Map<number, Record<string, string[]>>()
  savedFilters.forEach((savedFilter, index) => {
    const selection = results[index]?.data
    if (selection) {
      selectionsById.set(savedFilter.id, selection)
    }
  })

  return selectionsById
}
